import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Link } from '@vk-hr-tek/ui/Link';
import { Icon } from '@vk-hr-tek/ui/Icon';

import { SearchSitesAllOption } from '../SearchInput.types';

const getIcon = (
  group: SearchSitesAllOption['group'],
  kind: SearchSitesAllOption['kind'],
) => {
  switch (group) {
    case 'sites':
      return 'globe_outline';
    case 'pages':
      return 'globe_outline';
    case 'lists':
      return 'list_bullet_outline';
    case 'files':
      return kind && kind === 'folder'
        ? 'folder_simple_outline'
        : 'document_outline';
    default:
      const exhaustiveCheck: never = group;

      return exhaustiveCheck;
  }
};

interface SearchOptionSitesAllProps {
  option: SearchSitesAllOption;
}

export const SearchOptionSitesAll = ({ option }: SearchOptionSitesAllProps) => {
  return (
    <Box width="100%" p="8">
      <Link href={option.link} variant="simple" display="block">
        <Box display="flex" alignItems="center" gap="12">
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            radius="m"
            bgcolor="bg.greyscale.secondary"
            minHeight="40px"
            minWidth="40px"
            height="40px"
            width="40px"
          >
            <Icon
              name={getIcon(option.group, option.kind)}
              color="accent.text.blue"
              size="24"
            />
          </Box>
          <Box>
            <Typography
              maxLinesCount={2}
              variant="body3"
              color="text.light.primary"
              wordBreak="break-all"
            >
              {option.name}
            </Typography>
          </Box>
        </Box>
      </Link>
    </Box>
  );
};
